// removed by extract-text-webpack-plugin
module.exports = {"canvas":"canvas-component__canvas__2hsus"};


//////////////////
// WEBPACK FOOTER
// ./src/components/canvas-component/canvas-component.scss
// module id = 40
// module chunks = 0